const imgBlock = document.querySelector(".tangent-img");
const quizContainer = document.querySelector(".quiz-block")
const progressBlock = document.querySelector(".tangent-quiz-progress-block");

let currentQuestion = 0;

let currentQuizStep = 0;

function getQuizImages() {
  return window.matchMedia("(max-width: 768px)").matches
    ? window.quizMobileImages
    : window.quizImages;
}

// Set correct initial image based on device
const initialImages = getQuizImages();

if (imgBlock && initialImages[0]) {
  imgBlock.src = initialImages[0];
}

// preload all images
Object.values(window.quizImages).forEach((src) => {
  const img = new Image();
  img.src = src;
});

Object.values(window.quizMobileImages).forEach((src) => {
  const img = new Image();
  img.src = src;
});

window.addEventListener("quiz_progress", (e) => {
  const [current, total] = e.detail.split("_").map(Number);

  currentQuizStep = current;

  progressBlock.style.display = current == 0 ? "none" : "flex";

  if(current != 0){
    handleProgress(current - 1);
  }

  const images = getQuizImages();

  if (images[current]) {
    imgBlock.src = images[current];
  }

  quizContainer.style.background = current == 0 ? "#fff" : "#CEC2B4";
  quizContainer.style.justifyContent = current == 0 ? "center" : "start";
});

window.addEventListener("quiz_initialized", (e) => {
    let [current, total] = e.detail.split("_").map(Number);

    const width = 100 / total;

    while (total > 0) {
        const progressbar = document.createElement("div");

        progressbar.classList.add("progress-bar");
        progressbar.style.width = `${width}%`;

        const activeBar = document.createElement("div");
        activeBar.classList.add("progress-fill");

        progressbar.appendChild(activeBar);
        progressBlock.appendChild(progressbar);

        total--;
    }
});

/* progress bar handler */
function handleProgress(current) {
  const bars = document.querySelectorAll(".progress-fill");

  if(current >= currentQuestion){  //forward progress animation
    const previous = current - 1;
    const previousProgressBar = bars[previous];
    const currentProgressBar = bars[current];

    if(previousProgressBar) reduce(previousProgressBar, "right");

    setTimeout(() => {
      if(currentProgressBar) fill(currentProgressBar, "left");
    }, 100);
  }

  if(current < currentQuestion){ //backward progress animation
    const previousProgressBar = bars[currentQuestion];
    const currentProgressBar = bars[current];

    if(previousProgressBar) reduce(previousProgressBar, "left");

    setTimeout(() => {
      if(currentProgressBar) fill(currentProgressBar, "right");
    }, 100);
  }

  currentQuestion = current;
}

function setDirection(fill, direction) {
    if (direction === "left") {
        fill.style.left = "0";
        fill.style.right = "auto";
    } else {
        fill.style.left = "auto";
        fill.style.right = "0";
    }
}

function fill(fill, direction = "left") {
    setDirection(fill, direction);
    let width = 0;

    const interval = setInterval(() => {
        width += 5;
        fill.style.width = `${width}%`;
        if (width >= 100) clearInterval(interval);
    }, 10);
}

function reduce(fill, direction = "left") {
    setDirection(fill, direction);
    let width = 100;

    const interval = setInterval(() => {
        width -= 5;
        fill.style.width = `${width}%`;
        if (width <= 0) clearInterval(interval);
    }, 10);
}

const mobileQuery = window.matchMedia("(max-width: 768px)");

mobileQuery.addEventListener("change", () => {
  const images = getQuizImages();

  if (images[currentQuizStep]) {
    imgBlock.src = images[currentQuizStep];
  }
});